import { memo, useEffect, useState } from 'react'

import { POneEvent } from '@modules/auth/hooks/types'
import { Company } from '@modules/search/types'
import { Box } from '@mui/material'
import { useScreenDimensions } from '@shared/hooks/useScreenDimensions'
import { useQuery } from '@tanstack/react-query'

import searchApi from '../../search/api'
import LoadingSkeleton from '../AssetsOverview/LoadingSkeleton'
import CompanyCard from '../CompanyCard'
import { ProfileOuterWrapper, ProfileWrapper } from '../index.styles'
import DelegateSectionsList from './DelegateSectionsList'

const SECTIONS_PER_PAGE = 5

export interface DelegatesOverviewProps {
  companyId?: Company['id']
}

const DelegatesOverview = ({ companyId }: DelegatesOverviewProps) => {
  const [eventsList, setEventsList] = useState<POneEvent[]>([])
  const [page, setPage] = useState<number>(1)
  const { isDesktop } = useScreenDimensions()
  const { data, isLoading } = useQuery({
    queryKey: [searchApi.getCompanyEvents.key, companyId],
    queryFn: () => searchApi.getCompanyEvents.fn({ companyId }),
    enabled: !!companyId,
  })

  useEffect(() => {
    if (data?.events) {
      setEventsList([...data.events.slice(0, page * SECTIONS_PER_PAGE)])
    }
  }, [data?.events, page])

  const onViewMoreClick = () => {
    setPage(page + 1)
  }

  const allSectionsDisplayed = eventsList?.length === data?.events?.length

  return (
    <ProfileOuterWrapper customMaxWidth="1260px">
      <ProfileWrapper>
        <Box width="100%">
          {!isLoading ? (
            <DelegateSectionsList
              eventsList={eventsList}
              companyId={companyId}
              onViewMoreClick={onViewMoreClick}
              allSectionsDisplayed={allSectionsDisplayed}
            />
          ) : (
            <LoadingSkeleton />
          )}
        </Box>
        {companyId && isDesktop && <CompanyCard companyId={companyId} />}
      </ProfileWrapper>
    </ProfileOuterWrapper>
  )
}

export default memo(DelegatesOverview)
